import type { CSSProperties } from 'react'

/**
 * Faz o papel de `style="..."` do site institucional: o design foi aprovado como protótipo (artefato Claude)
 * com estilo inline literal por elemento, então em vez de reescrever cada regra à mão como objeto JS
 * (centenas de elementos, alto risco de erro de digitação) parseamos a mesma string aqui.
 */
export function css(str: string): CSSProperties {
  const out: Record<string, string> = {}
  for (const decl of str.split(';')) {
    const i = decl.indexOf(':')
    if (i === -1) continue
    const prop = decl.slice(0, i).trim()
    const val = decl.slice(i + 1).trim()
    if (!prop || !val) continue
    const camel = prop.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase())
    out[camel] = val
  }
  return out as CSSProperties
}
